import {Button, FormGroup, Input} from "reactstrap";
import React from "react";
import PropTypes from "prop-types";

const FilterComponent = ({filterText, onFilter, onExport}) => (
    <>
        {onExport ? <FormGroup className="col-md-1 p-2">
            <Button className="btn btn-danger" onClick={e => onExport(e.target.value)}>Export</Button>
        </FormGroup> : <div className="col-md-1"/>}
        {onFilter ?
            <>
                <div className="col-md-8"/>
                <FormGroup className="col-md-3">
                    <Input
                        id="search"
                        type="text"
                        placeholder="Search"
                        value={filterText}
                        onChange={onFilter}
                    />
                </FormGroup>
            </>
            : <div className="col-md-11"/>
        }
    </>
);

FilterComponent.propTypes = {
    filterText: PropTypes.string,
    onFilter: PropTypes.func,
    onExport: PropTypes.func
};

export default FilterComponent;